import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { MeContextProvider } from './context/MeContextProvider';
import './styles/app.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <MeContextProvider>
        <App />
      </MeContextProvider>
    </BrowserRouter>
  </StrictMode>,
);
